const SECOND = 1e3;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export const STALE = {
	SECONDS: {
		FIFTEEN: 15 * SECOND,
		THIRTY: 30 * SECOND,
	},
	MINUTES: {
		ONE: MINUTE,
		THREE: 3 * MINUTE,
		FIVE: 5 * MINUTE,
		FIFTEEN: 15 * MINUTE,
		THIRTY: 30 * MINUTE,
	},
	HOURS: {
		ONE: HOUR,
	},
	INFINITY: Infinity,
};

export const GCTIME = {
	MINUTES: {
		FIVE: 5 * MINUTE,
	},
	DAYS: {
		SEVEN: 7 * DAY,
	},
};
